/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-nested-ternary */
import { Header } from "components/Common/Header";
import Text from "components/Common/Text";
import Sheet from "react-modal-sheet";

import clock from "assets/clock.svg";

import "./styles.css";
import { useEvents } from "hooks/useEvents";
import { useNavigate } from "react-router-dom";
import { formatFirestoreTimeStamp } from "utils";
import EditTeesListHeader from "components/Holes/editTeesList/editTeesListHeader";
import { Button } from "components/Common/button";
import uuid from "react-uuid";
import {
  addUserInTeam,
  addUserInTeeTimeCustomEvent,
  createEvent,
} from "services/firebase";
import { useAuth } from "hooks/useAuth";
import { useUserData } from "hooks/useUserData";
import { useState } from "react";
import HeaderIndicator from "components/Common/Header/sub/HeaderIndicator";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";

function CreateEventScreen() {
  const { user } = useAuth();
  const userData = useUserData(user);
  const navigate = useNavigate();

  const generateGolfEventName = () => {
    const adjectives = [
      "Epic",
      "Wacky",
      "Legendary",
      "Chaotic",
      "Mystical",
      "Turbo",
      "Secret",
      "Wild",
      "Ultra",
      "Spicy",
      "Quantum",
      "Sneaky",
    ];

    const nouns = [
      "Swing Showdown",
      "Putter Madness",
      "Hole-in-One Fiesta",
      "Driver Derby",
      "Bogey Bash",
      "Birdie Bonanza",
      "Caddy Chaos",
      "Eagle Extravaganza",
      "Green Wars",
      "Fore Frenzy",
      "Albatross Adventure",
      "Golfocalypse",
    ];

    // Деструктурируем случайные значения из массивов
    const { randomAdjective, randomNoun } = {
      randomAdjective:
        adjectives[Math.floor(Math.random() * adjectives.length)],
      randomNoun: nouns[Math.floor(Math.random() * nouns.length)],
    };

    return `${randomAdjective} ${randomNoun}`;
  };

  const [modalState, setModalState] = useState({
    isOpen: false,
    type: 0,
    eventName: generateGolfEventName(),
  });

  const events = useEvents();

  if (!events) {
    return <ActivityIndicator />;
  }

  const handleInputChange = ({ target: { value } }) => {
    setModalState((prevState) => ({
      ...prevState,
      eventName: value,
    }));
  };

  const onCreateEvent = async (type, eventName) => {
    const eventId = uuid();
    const teeTimeId = uuid();

    await createEvent(eventId, userData, type, eventName, teeTimeId);
    navigate(`/event/${eventId}/${teeTimeId}/holes`);
  };

  async function bookTeeTime(event, teamCode) {
    const { id, teeTimes, teamsPlay } = event;
    const [teeTime] = teeTimes;

    const { id: teeTimeId } = teeTime;

    let teamId = null;

    if (teamsPlay) {
      const { teams } = teeTime;

      const emptyTeam = teams.find((team) => team.users.length === 0);

      if (emptyTeam) {
        // eslint-disable-next-line prefer-destructuring
        teamId = emptyTeam.teamId;
      }
    }
    if (event.players.includes(userData.phone)) {
      navigate(`/event/${id}/${teeTimeId}/holes`);
    }

    const { isAdded, alreadyPlay } = teamsPlay
      ? await addUserInTeam(id, teeTimeId, teamId, userData, teamCode)
      : await addUserInTeeTimeCustomEvent(id, teeTimeId, userData, teamCode);

    if (isAdded) {
      navigate(`/event/${id}/${teeTimeId}/holes`);
    }
    if (alreadyPlay) {
      navigate(`/event/${id}/${teeTimeId}/holes`);
    }

    // const isBookingPossible =
    //   !isBooked && typeof user.handicap === "number" && user.phone && eventId;
    // // eslint-disable-next-line no-extra-boolean-cast
    // if (isBookingPossible) {
    //   setIsBooked(true);
    //   const { isAdded, alreadyPlay } = teamId
    //     ? await addUserInTeam(eventId, teeTimeId, teamId, user)
    //     : await addUserInTeeTimeCustomEvent(eventId, teeTimeId, user);
    //   if (isAdded) {
    //     navigation(`/event/${eventId}`);
    //   }
    //   if (alreadyPlay) {
    //     navigation(`/event/${eventId}`);
    //   }
    // }
    // return setIsBooked(true);
  }

  return (
    <>
      <section
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          backgroundPosition: "center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundColor: "rgb(250, 250, 250, 0.93)",
          backgroundBlendMode: "soft-light",
        }}
      >
        <Header hideQr />

        <div
          style={{
            flex: 1,
            width: "100%",
            padding: "2rem",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              padding: "0px 0px 14px 0px",
            }}
          >
            <img src={clock} alt="clock" />
            <Text as="H4" bold style={{ color: "gray", marginLeft: 4 }}>
              Last Events
            </Text>
          </div>
          {events.length >= 1 ? (
            events?.map((event) => {
              const dateStr = formatFirestoreTimeStamp(
                event.timestamp,
                "EEEE, MM/dd",
              );

              const { teeTimes } = event;

              const [teeTime] = teeTimes || [];

              const users = teeTime?.users;

              return (
                <div
                  key={event.id}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: "#f3f3f3",
                    width: "100%",
                    padding: 14,
                    borderRadius: 14,
                    marginBottom: 8,
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Text as="H4" style={{ color: "black" }}>
                      {dateStr} Big Game
                    </Text>
                    <Text as="P3" style={{ color: "black" }}>
                      {event.title}
                    </Text>

                    <Text as="P3" style={{ color: "black" }}>
                      Created by {event.createdBy.lastName}
                    </Text>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      {users?.find((usr) => usr.phone === userData.phone) ? (
                        <Button
                          style={{
                            marginTop: 12,
                            backgroundColor:
                              event?.teeTimesSubmitted?.length <= 0
                                ? "#ffb31a"
                                : null,

                            color:
                              event?.teeTimesSubmitted?.length <= 0
                                ? "#000"
                                : null,
                          }}
                          title={
                            event?.teeTimesSubmitted?.length <= 0
                              ? "Playing"
                              : "Completed"
                          }
                          onPress={() =>
                            navigate(`/event/${event.id}/${teeTime.id}/holes`)
                          }
                        />
                      ) : users?.length >= 0 ? (
                        <>
                          <Button
                            style={{
                              marginTop: 12,
                            }}
                            title={
                              users?.find(
                                (usr) => usr.displayName === "The 2 Man",
                              )
                                ? "2 Man Close"
                                : "2 Man Open"
                            }
                            onPress={() => bookTeeTime(event, 0)}
                            blocked={
                              !!(
                                users &&
                                users.find(
                                  (usr) => usr.displayName === "The 2 Man",
                                )
                              )
                            }
                          />
                          <Button
                            style={{
                              marginTop: 12,
                              marginLeft: 12,
                            }}
                            title={
                              users?.find(
                                (usr) => usr.displayName === "The 3 Man",
                              )
                                ? "3 Man Close"
                                : "3 Man Open"
                            }
                            onPress={() => bookTeeTime(event, 1)}
                            blocked={
                              !!(
                                users &&
                                users.find(
                                  (usr) => usr.displayName === "The 3 Man",
                                )
                              )
                            }
                          />
                        </>
                      ) : null}
                    </div>
                  </div>
                  <HeaderIndicator
                    live={event?.teeTimesSubmitted?.length <= 0}
                  />
                </div>
              );
            })
          ) : (
            <Text
              as="H4"
              bold
              style={{
                color: "black",
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#f3f3f3",
                width: "100%",
                padding: 14,
                borderRadius: 14,
                marginBottom: 8,
              }}
            >
              No Events Live Today
            </Text>
          )}
        </div>

        {/* Фиксированная кнопка */}
        <button
          type="button"
          style={{
            position: "fixed",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#3a82f6",
            color: "white",
            padding: "12px 24px",
            borderRadius: "32px",
            border: "none",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "bold",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          }}
          onClick={() =>
            setModalState((prevState) => ({
              ...prevState,
              isOpen: true,
            }))
          }
        >
          Create Event
        </button>
      </section>

      <Sheet
        isOpen={modalState.isOpen}
        onClose={() =>
          setModalState((prevState) => ({
            ...prevState,
            isOpen: false,
          }))
        }
        style={{
          maxWidth: 600,
          margin: "auto",
        }}
        detent="full-height"
        // ref={sheetRef}
      >
        <Sheet.Container
          style={{
            backgroundColor: "#EDEFEF",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
          }}
        >
          <Sheet.Header>
            <EditTeesListHeader
              courseName="Event Name"
              onClose={() =>
                setModalState((prevState) => ({
                  ...prevState,
                  isOpen: false,
                }))
              }
            />
          </Sheet.Header>
          <Sheet.Content
            style={{
              // paddingBottom: sheetRef.current?.y,
              padding: "16px",
            }}
          >
            <Text as="P3" bold style={{ color: "black" }}>
              Event Name
            </Text>
            <input
              type="text"
              placeholder="Match with bla bla"
              value={modalState.eventName}
              onChange={handleInputChange}
              style={{
                height: 52,
                width: "100%",
                minWidth: 329,
                borderRadius: 16,
                marginTop: 8,
                paddingLeft: 10,
              }}
            />
            <Button
              title="Create Event (2 Man)"
              style={{ width: "100%", marginBottom: 14, marginTop: 16 }}
              onPress={() => onCreateEvent(0, modalState.eventName)}
              type="submit"
              //   blocked={blocked}
            />
            <Button
              title="Create Event (3 Man)"
              style={{ width: "100%", marginBottom: 26 }}
              onPress={() => onCreateEvent(1, modalState.eventName)}
              type="submit"
              //   blocked={blocked}
            />
          </Sheet.Content>
        </Sheet.Container>

        <Sheet.Backdrop />
      </Sheet>
    </>
  );
}

export { CreateEventScreen };
